import { InjectionToken } from "@angular/core";

export const DIRECTORY_ID = new InjectionToken<string>('directoryId');